import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=524e4174&scoped=true&"
import script from "./FilterSelector.vue?vue&type=script&lang=js&"
export * from "./FilterSelector.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelector.vue?vue&type=style&index=0&id=524e4174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e4174",
  null
  
)

export default component.exports